// TODO : Discuss if there is a difference between catalogue and products, seems pretty much interchangable to me at this point.

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { ICountry } from '@boma/client-shared';
import {
  ICatalogueItem,
  ICategorySearchResult,
  IDuplicateProductRequest,
  IProduct,
  IProductCountryRequest,
  IProductCreateRequest,
  IProductCreateResponse,
} from '@boma/supplier-portal/shared/entities';
import { HelperFunctionsService } from '../helper-functions/helper-functions.service';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient,
    private helperService: HelperFunctionsService
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  getProduct(productId: any) {
    // TODO iproduct and icatalogue pretty much the same (both return properties one interface just doesnt have it on it) we should probably unify
    return this.httpClient.get<ICatalogueItem>(
      `${this.base}api/v${this.version}/Products/${productId}`
    );
  }

  createProduct(params: IProductCreateRequest) {
    this.helperService.sanitizeParams(params);
    return this.httpClient.post<IProductCreateResponse>(
      `${this.base}api/v${this.version}/Products`,
      {
        ...params,
      }
    );
  }

  duplicateProduct(params: IDuplicateProductRequest) {
    return this.httpClient.post<IProductCreateResponse>(
      `${this.base}api/v${this.version}/Products/${params.entityId}/Duplicate`,
      params
    );
  }

  updateProduct(productId: string, params: IProductCreateRequest) {
    this.helperService.sanitizeParams(params);
    return this.httpClient.put<IProductCreateResponse>(
      `${this.base}api/v${this.version}/Products/${productId}`,
      {
        ...params,
      }
    );
  }

  getCountries() {
    return this.httpClient.get<ICountry[]>(
      `${this.base}api/v${this.version}/Countries`
    );
  }

  getTaxDefinitions(countryId: string) {
    return this.httpClient.get<ICountry>(
      `${this.base}api/v${this.version}/Countries/${countryId}`
    );
  }

  uploadProductImage(file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.post<string>(
      `${this.base}api/v${this.version}/Products/UploadImage`,
      formData
    );
  }

  searchCategories(searchTerm: string) {
    return this.httpClient.get<ICategorySearchResult[]>(
      `${this.base}api/v${this.version}/Search/Categories/Suggestions?query=${searchTerm}`
    );
  }

  updateCountryDetails(params: IProductCountryRequest) {
    return this.httpClient.post<IProduct>(
      `${this.base}api/v${this.version}/Products/${params.entityId}/CountryDetails`,
      params
    );
  }
}
